import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');
const queryString = require('querystring')
 
var UserService = {


    findAllUserList: function($data)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="userdrop"
           $options.method="get"
           if(!$data) {
               $options.data = $data
           }
           ApiService.request($options)
               .then(response => {
                  // console.log('Gpt the data');
                   resolve(response.data.data)
               }).catch(error=> {
                   reject(error);
               })
       });

   },
   resetPassword:function($data) {
    return new Promise(function(resolve,reject) {
        var $options= {};
        $options.url ="resetPassword"
        $options.url ="resetPassword?filter="+JSON.stringify($data)
        ApiService.request($options)
            .then(response => {
               // console.log('Gpt the data');
                resolve(response.data.data)
            }).catch(error=> {
                reject(error);
            })
        }); 

    },
    scan: function($data)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'authServer/scan/1   ?'+queryString.stringify($data)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    logout: function()
    {
        localStorage.removeItem('tiburaMwsUser');

    },
    authenticate:function($user) 
    {
        return new Promise(function(resolve,reject) {
            var $options= {};
            console.log($user)
            $options.url ="authenticate"
            $options.method="post"
            $options.data = $user
            ApiService.request($options)
                .then(response => {
                    //console.log('Gpt the data');
                    resolve(response.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    activate:function($user) 
    {
        return new Promise(function(resolve,reject) {
            var $options= {};
            console.log($user)
            $options.url ="activate/"+$user.id
            $options.method="post"
            $options.data = {"activation_key":$user.activation_key}
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    //console.log('Gpt the data');
                    resolve(response.data)
                }).catch(error=> {
                    console.log(error)
                    reject(error.response.data.data.Error);
                })
        });
    },
    checkUser:function($data) {

       // return UserService.findAll({"email":$data})
       return new Promise(function(resolve,reject) {
        var $options= {};
        if($data) {
            if($data.id) {
                $options.url ="validateEmail/"+$data.id
            } else {
                $options.url ="validateEmail?filter="+JSON.stringify({"email":$data})
            }
            //$options.data=$data
        }
        $options.method="get"
        //$options.data = $id
        ApiService.request($options)
            .then(response => {
               // console.log('Gpt the data');
                resolve(response.data.data)
            }).catch(error=> {
                reject(error);
            })
    });

    },
    findAll: function($data) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            if($data) {
               
                //     $options.url ="user/"+$data.id
                // } else {
                    $options.url ="user?filter="+JSON.stringify($data)
               
                //$options.data=$data
            }
            $options.method="get"
            //$options.data = $id
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.email= $data.email;
            $options.data.team = $data.team;
            $options.data.user_type = $data.user_type;
            $options.data.auth_service_id=$data.auth_service_id 
            $options.data.auth_type='ldap'
            $options.data.ldap_string= $data.ldap_string
            $options.data.logo_profile_id =$data.logo_profile_id
            $options.data.default_company_id = $data.company_id
            $options.username = $data.email.substring(0,$data.email.indexOf('@'))
            $options.company_id =1;
            $options.data.company_list = $data.company_list
            //$options.default_company_id=$data.default_company_id
            $options.data.super_user =0;
            $options.data.active = 1;
            $options.data.lock_user  =1
          //  $options.data.user_type='US'
            $options.data.mobile= $data.mobile;
            $options.data.first_name= $data.first_name;
            $options.data.last_name = $data.last_name; //$data.stateId;
            $options.url = "user";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
            $options.data.email= $data.email;
            $options.data.mobile= $data.mobile;
            $options.data.first_name= $data.first_name;
            $options.data.logo_profile_id =$data.logo_profile_id
            $options.data.last_name = $data.last_name; //$data.stateId;
            $options.data.ldap_stirng = $data.last_string
            $options.data.username = $data.username
            $options.data.super_user= $data.super_user
            $options.data.lock_user = $data.lock_user
            $options.data.active = $data.active
            $options.data.company_list = $data.company_list
            $options.data.user_type = $data.user_type
            $options.data.auth_service_id = $data.auth_service_id
            $options.url = "user/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
   
    validate: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            $options.url ='company/validate'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {

                }).catch(error => {

                });
            });

    },
    formatData: function($data) 
    {
        var $i =0;
        var $companies = $data.data.data;
        var $companyList = []; 
        var $length = $companies.length; 
        console.log($companies)
        for($i=0;$i<$length;$i++) { 
            var $options = {};
            $options.id = $companies[$i].companies.id;
            $options.name = $companies[$i].companies.companyName;
            $options.city = $companies[$i].companies.city;
            $options.first_name= $companies[$i].first_name;
            $options.last_name=$companies[$i].last_name;
            $options.default_company_id =$companies[$i].default_company_idfs
            $options.countryName = 'United States' //$companies[$i].countryName;
            $options.stateName = $companies[$i].stateName;
            $options.active = $companies[$i].active=1 ? 'Active' : 'InActive'
            $options.modified =$companies[$i].modified
            $options.expiry = $companies[$i].expires_on
            $options.authTypeDesc =$companies[$i].companies.auth_type;
            $options.twoFactorAuth  = $companies[$i].companies.two_factor_auth==1 ? 'Enabled' : 'Disabled';
            $companyList.push($options)
            //$company.push($options)
            console.log('record finsihed');

        }
        console.log('returned data')
        return $companyList;
    },
    update:function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data;
            $options.url = "user/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {

                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    sendInvite:function($id) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = "sendInvite/"+$id;
            $options.method="get"
            console.log($options)
            ApiService.request($options)
                .then(response => {

                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default UserService;